import React from "react";
import styled from "styled-components";

export default styled.div`
    width: 101px;
    height: 101px;
    border-radius: 500px;
    background: gray;
    display: inline-block;
`;